namespace Areas.Submittal.View {
    "use strict";

    var tabItems = Areas.createTabsWithSameAction("Submittal", "View",
        ["Profile", "Tracking"]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }

    export function returnToListFromTab() {
        var linkInfo = "/Submittal/List/Active";
        location.href = linkInfo;

    }

    export function addGridButtons(e: any) {
        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { class: "dxButton lightblue" },
            text: "Create",
            hint: "Create",
            type: "default",
            icon: "plus",
            onClick: () => Areas.Submittal.List.showCreate()
        }, "before");
    }


    export function columnViewLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.submittalTrackingProfileId; },
            "<a href= '/Submittal/Profile/View/{placeholder}'>View</a>");
    }
}